module.exports = __webpack_public_path__ + "static/media/business_lead_small.2ce2b4a4.jpg";